var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{ref:"mobile-button",staticClass:"back-button",attrs:{"type":"button","aria-label":_vm.$t('navigateBack')},on:{"click":_vm.navigateBackOne}},[_c('SvgIcon',{attrs:{"name":"ChevronLeftIcon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }